import React from 'react'
import { ProjectStatus } from 'controllers/Project/ProjectStateMachine'
import {
  useSalesLeadTimeData,
  GetSalesLeadTimeData,
} from './useSalesLeadTimeData'
import { DashboardWidget, KPITargetConfiguration } from '../DashboardWidget'
import { SalesLeadTimeGraph } from '../SalesLeadTimeGraph'
import { KpiFiltersAndTargetConfiguration } from '../KpiFiltersAndTargetConfiguration'
import { LocalizedListItemText } from 'components/Localization/LocalizedListItemText'
import { KPI } from 'controllers/Analytics/SalesLeadTimeController'
import { useTranslation } from 'react-i18next'

export const ResponseCycleTime = (
  props: KPITargetConfiguration & {
    onError: (kpi: KPI, message: string) => void
  }
) => {
  const {
    controller,
    loading,
    salesGraphData,
    onSaveConfiguration,
    onSaveTarget,
  } = useSalesLeadTimeData(
    ProjectStatus[ProjectStatus.REQUESTED],
    ProjectStatus[ProjectStatus.QUOTED],
    'response-time',
    props.value,
    props.unit,
    KPI.responseTime,
    props.onError
  )

  const { t } = useTranslation('common')
  return (
    <>
      <DashboardWidget
        subtitle={
          <LocalizedListItemText
            primaryTranslationKey={'common:dashboard-response-time-title'}
            primaryTypographyProps={{
              variant: 'h5',
            }}
            secondaryTranslationKey={'common:dashboard-response-time-subtitle'}
          />
        }
        GraphComponent={<SalesLeadTimeGraph data={salesGraphData} />}
        ConfigurationComponent={
          <KpiFiltersAndTargetConfiguration
            targetValueLabel={t(
              'common:dashboard-response-cycle-target',
              'target response time'
            )}
            configuration={controller.GetGraphConfiguration()}
            saveConfiguration={onSaveConfiguration}
            saveTarget={onSaveTarget}
          />
        }
        loading={salesGraphData === undefined || loading['get-sales-lead-time']}
        empty={
          salesGraphData !== undefined &&
          !Boolean(controller.SalesLeadTimeData?.length)
        }
        onRefresh={async () =>
          await GetSalesLeadTimeData(
            controller,
            ProjectStatus[ProjectStatus.REQUESTED],
            ProjectStatus[ProjectStatus.QUOTED]
          )
        }
      />
    </>
  )
}
